(function (Drupal, once) {
  Drupal.behaviors.logoSwapEffect = {
    attach(context) {
      once('logo-swap-init', '.logos-block__slider', context).forEach(() => {
        const slides = Array.from(document.querySelectorAll('.logo-swap-container'))
          .filter(container => container.querySelector('.colored'));

        if (slides.length === 0) return;

        let current = 0;

        setInterval(() => {
          slides.forEach((container, index) => {
            const gray = container.querySelector('.gray');
            const colored = container.querySelector('.colored');

            if (!gray || !colored) return;

            if (index === current) {
              gray.style.opacity = '0';
              colored.style.opacity = '1';
            } else {
              gray.style.opacity = '1';
              colored.style.opacity = '0';
            }
          });

          current = (current + 1) % slides.length;
        }, 4000);
      });
    }
  };
})(Drupal, once);